import React from 'react';
import Button from '../common/Button';
//import Icon from '../common/Icon';

interface NavigationProps {
  onGenerateClick: () => void;
  onLogoClick: () => void;
}

const Navigation: React.FC<NavigationProps> = ({ onGenerateClick, onLogoClick }) => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <nav className="flex items-center justify-between px-8 py-6 bg-white border-b border-brand-grey01 sticky top-0 z-50 no-print">
      <div className="flex items-center gap-3">
        <div
          className="w-10 h-10 rounded-full border-2 border-brand-black flex items-center justify-center font-extrabold text-sm rotate-[-5deg] transition-transform hover:rotate-0 cursor-pointer"
          onClick={onLogoClick}
        >
          RD
        </div>
        <span className="font-bold text-xl tracking-tight hidden sm:inline">
          Rethink Demand
        </span>
      </div>
      <div className="flex items-center gap-4">
        {/*<Button
          variant="secondary"
          size="sm"
          icon="auto_awesome"
          onClick={onGenerateClick}
          className="hidden lg:flex"
        >
          Generate Intel
        </Button>*/}
        <div className="h-8 w-[1px] bg-brand-grey01 hidden md:block" />
        <Button
          variant="ghost"
          size="sm"
          icon="picture_as_pdf"
          onClick={handlePrint}
        >
          PDF
        </Button>
      </div>
    </nav>
  );
};

export default Navigation;
